import { makeStyles } from '@material-ui/styles';

import { MainButton, Dropdown, CalendarEventLine } from '@bizzabo/design-system';
import { UserPreview } from '@bizzabo/entities';

import { ScheduledMeeting } from '../../types';
import useTypeTracking from '../../../../analytics';
import AddToCalendar from '../AddToCalendar';

type AddToCalendarProps = {
    meeting: ScheduledMeeting;
    otherUser: UserPreview;
    buttonClassName?: string;
    disabled?: boolean;
};

const AddToCalendarrButton: React.FC<AddToCalendarProps> = ({
    meeting,
    otherUser,
    buttonClassName,
    disabled,
}) => {
    const { trackClickEvent } = useTypeTracking();
    const classes = useStyles();

    const openDropdown = () => {
        trackClickEvent({
            subCategory: 'ADD_TO_CALENDAR',
        });
    };

    return (
        <Dropdown
            button={() => (
                <MainButton
                    before={<CalendarEventLine className={classes.calendarIcon} />}
                    className={buttonClassName}
                    disabled={disabled}
                    onClick={openDropdown}
                >
                    Add to calendar
                </MainButton>
            )}
            placement="bottom"
            onClose={e => e.stopPropagation()}
        >
            {closeDropdown => (
                <AddToCalendar otherUser={otherUser} meeting={meeting} onClose={closeDropdown} />
            )}
        </Dropdown>
    );
};

const useStyles = makeStyles(
    () => ({
        calendarIcon: {
            fontSize: 14,
        },
    }),
    { classNamePrefix: 'schedule-add-to-calendar' }
);

export default AddToCalendarrButton;
